import {type Editor} from '@tiptap/react';
import {sendToStatist} from 'packages/statist';

import {hasProtocol, prepareForm} from '../utils';

import {InlineLinkForm} from './inline-link-form';

type FloatingLinkPopoverFormProps = {
    editor?: Editor;
    onTogglePopover: () => void;
}

export const FloatingLinkPopoverForm = ({editor, onTogglePopover}: FloatingLinkPopoverFormProps) => {
    const handleSubmit = (linkValue: string) => {
        if (!editor || linkValue.trim().length === 0) {
            onTogglePopover();
            return;
        }

        const {url} = prepareForm(linkValue);

        sendToStatist('editor.link.apply', {
            highlight: true,
            insert: false,
            text: false,
            protocol: hasProtocol(linkValue.trim()),
        });

        editor.commands.addLinkToSelection({href: url});
        onTogglePopover();
    };

    return <InlineLinkForm onSubmit={handleSubmit} />;
};
